// extracted by mini-css-extract-plugin
export default {"wrapper":"Ck","form":"Dk","required":"Ek","label":"Fk","small":"Gk","noMargin":"Hk","success":"Ik","circle":"Jk","successText":"Kk","appointment":"Lk"};